import React, { Fragment, useState, useEffect } from 'react';
import { wsFindBy, wsGetAll, wsCreate, wsUpdate } from 'services/WService.js';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';

import styles from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js';

// material-ui icons
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Toasty, useToasty } from 'hooks/Toasty';

import ContactModal from './Modal/ContactModal';
import { WithApp } from 'contexts/appContext';
import Add from '@material-ui/icons/Add';
import { ContactPhone } from '@material-ui/icons';

const StyleTable = {
  table: {
    minWidth: 1700
  }
};

const useStyles = makeStyles(styles);
const useStyleTable = makeStyles(StyleTable);

export default WithApp(function Contact(props) {
  const classes = useStyles();
  const claseTable = useStyleTable();
  const [notify, showNotify] = useToasty();

  const bPartner = props.businessPartner;
  const [contacts, setContacts] = useState([]);
  const [contactId, setContactId] = useState();

  const [showModal, setShowModal] = useState(false);

  async function ListContact() {
    let response = await wsFindBy(
      'base/business-partner-contact',
      'base_business_partner_id',
      bPartner.id
    );
    if (response.success) setContacts(response.data);
  }

  async function save(data) {
    let response = {};
    if (!!contactId) {
      response = await wsUpdate('base/business-partner-contact', contactId, data);
    } else {
      /* console.log(data); */
      data = { ...data, base_business_partner_id: bPartner.id };
      response = await wsCreate('base/business-partner-contact', data);
    }
    if (response.success) {
      showNotify(response.message);
      ListContact();
      setShowModal(false);
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    ListContact();
  }, []);

  return (
    <Fragment>
      <ContactModal close={setShowModal} open={showModal} save={save} contactId={contactId} />
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_CONTACT_STORE}
              component={
                <CardIcon color="primary">
                  <ContactPhone style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                color={props.themeContext.buttonColorSuccess}
                onClick={() => {
                  setShowModal(true);
                }}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Contactos</h4>
          </CardHeader>
          <CardBody>
            <TableContainer component={Paper}>
              <Table className={claseTable.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>ID contacto</TableCell>
                    <TableCell>Nombre 1</TableCell>
                    <TableCell>Nombre 2</TableCell>
                    <TableCell>Apellidos</TableCell>
                    <TableCell>Dirección</TableCell>
                    <TableCell>Teléfono</TableCell>
                    <TableCell>Celular</TableCell>
                    <TableCell>Correo</TableCell>
                    <TableCell>Notas</TableCell>
                    <TableCell>Fec. nacimiento</TableCell>
                    <TableCell>Ciudad natal</TableCell>
                    <TableCell>Género</TableCell>
                    <TableCell>Profesión</TableCell>
                    <TableCell align="right">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {contacts.map((contact, i) => {
                    return (
                      <TableRow key={i}>
                        <TableCell>{i + 1}</TableCell>
                        <TableCell>{contact.Name}</TableCell>
                        <TableCell>{contact.FirstName}</TableCell>
                        <TableCell>{contact.MiddleName}</TableCell>
                        <TableCell>{contact.LastName}</TableCell>
                        <TableCell>{contact.Address}</TableCell>
                        <TableCell>{contact.Tel1}</TableCell>
                        <TableCell>{contact.Cellolar}</TableCell>
                        <TableCell>{contact.E_MailL}</TableCell>
                        <TableCell>{contact.Notes1}</TableCell>
                        <TableCell>{contact.BirthDate}</TableCell>
                        <TableCell>{contact.BirthCity}</TableCell>
                        <TableCell>{contact.Gender}</TableCell>
                        <TableCell>{contact.Profession}</TableCell>
                        <TableCell align="right">
                          <AllowedGuard
                            permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_CONTACT_UPDATE}
                          >
                            <Button
                              justIcon
                              round
                              color={props.themeContext.buttonColorSuccess}
                              size="sm"
                              className={classes.marginRight}
                              onClick={() => {
                                setContactId(contact.id);
                                setShowModal(true);
                              }}
                            >
                              <EditIcon className={classes.icons} />
                            </Button>
                          </AllowedGuard>
                          {/* <Button
                            justIcon
                            round
                            color={props.themeContext.buttonColorDanger}
                            size="sm"
                            className={classes.marginRight}
                          >
                            <DeleteIcon className={classes.icons} />
                          </Button> */}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </CardBody>
        </Card>
      </GridItem>
    </Fragment>
  );
});
